import { Button } from '@revenuemarket/cds';
import { ButtonProps, Tooltip } from 'antd';
import { useRouter } from 'next/router';
import { DEMO_TRIAL_TOOLTIP_MSG } from '~constants/clobe';
import { useGetFinanceInfo } from '~hooks/queries/dashboard/query';
import { useCompanyId } from '~hooks/useCompanyId';
import useIsDemoTrial from '~hooks/useIsDemoTrial';
import { MIXPANEL_EVENT } from '~libs/mixpanel/event';
import { mixpanel } from '~pages/_app';

const RequestTermButton = ({ ...props }: ButtonProps) => {
  const { companyId } = useCompanyId();
  const { data } = useGetFinanceInfo({
    companyId,
  });
  const router = useRouter();
  const isDemoTrial = useIsDemoTrial();

  if (
    data?.Data?.data?.items[0]?.type === 'TERM_REQUESTED' ||
    (data?.Data?.data?.items[0]?.type === 'TERM_OFFERED' &&
      data?.Data?.data?.items[0]?.denialReason)
  ) {
    return null;
  }

  return (
    <Tooltip title={isDemoTrial ? DEMO_TRIAL_TOOLTIP_MSG : undefined}>
      <div
        style={{
          width: 'fit-content',
        }}
      >
        <Button
          buttonType="primary"
          buttonSize="large"
          onClick={() => {
            mixpanel.track(MIXPANEL_EVENT.HOME.CLICK_TERM_REQUEST);
            router.push(`/dashboard/term-request`);
          }}
          disabled={isDemoTrial}
          style={{
            width: 'fit-content',
          }}
        >
          우리 회사 한도 조회하기
        </Button>
      </div>
    </Tooltip>
  );
};

export default RequestTermButton;
